import React from 'react';
import { motion } from 'framer-motion';
import { Search, PenTool, Rocket } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Diagnóstico',
  description: 'Analizamos tu situación específica para identificar las mejores opciones legales y administrativas.',
  icon: <Search className="w-6 h-6 text-primary" data-id="element-257" />
}, {
  number: '02',
  title: 'Estrategia',
  description: 'Diseñamos una hoja de ruta personalizada y preparamos toda la documentación necesaria.',
  icon: <PenTool className="w-6 h-6 text-primary" data-id="element-258" />
}, {
  number: '03',
  title: 'Ejecución',
  description: 'Presentamos los trámites y realizamos el seguimiento hasta obtener la resolución favorable.',
  icon: <Rocket className="w-6 h-6 text-primary" data-id="element-259" />
}];
export function Process() {
  return <section className="py-20 bg-surface overflow-hidden" data-id="element-260">
      <div className="container mx-auto px-4 md:px-6" data-id="element-261">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-262">
          <div className="lg:w-1/2" data-id="element-263">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} data-id="element-264">
              <span className="text-primary font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-265">
                Cómo trabajamos
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-navy mb-6" data-id="element-266">
                Un proceso claro y transparente
              </h2>
              <p className="text-lg text-gray-600 mb-8" data-id="element-267">
                Sabemos que los trámites burocráticos pueden ser abrumadores.
                Por eso hemos simplificado nuestro método de trabajo en tres
                pasos sencillos para garantizar tu éxito.
              </p>

              <div className="relative" data-id="element-268">
                <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gray-200" data-id="element-269"></div>

                <div className="space-y-12" data-id="element-270">
                  {steps.map((step, index) => <motion.div key={index} initial={{
                  opacity: 0,
                  x: -20
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: index * 0.2
                }} className="relative flex gap-6" data-id="element-271">
                      <div className="relative z-10 flex-shrink-0 w-12 h-12 rounded-full bg-white border-2 border-primary flex items-center justify-center shadow-md" data-id="element-272">
                        {step.icon}
                      </div>
                      <div data-id="element-273">
                        <h3 className="text-xl font-bold text-navy mb-2" data-id="element-274">
                          {step.title}
                        </h3>
                        <p className="text-gray-600" data-id="element-275">{step.description}</p>
                      </div>
                    </motion.div>)}
                </div>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-1/2" data-id="element-276">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} className="relative rounded-3xl overflow-hidden shadow-2xl" data-id="element-277">
              <img src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Professional team meeting" className="w-full h-auto object-cover" data-id="element-278" />
              <div className="absolute inset-0 bg-navy/20" data-id="element-279"></div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}